import Browser from '@mindful-web/marko-web/browser';
import Shared from '@ab-media/package-global/browser';

Shared(Browser);

export default Browser;
